import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { KIcon } from "@kyburz/kdesign-system";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    alignItems: "center",
  },
}));

const InlineColumnFilter = ({
  column: { filterValue, id },
  setActiveFilter,
}: any) => {
  const classes = useStyles();

  const open = (e: any) => {
    e.stopPropagation();
    setActiveFilter(id);
  };

  return (
    <div className={classes.root}>
      <KIcon
        icon="search"
        color={filterValue ? "#2f80ed" : "#cccccc"}
        size={16}
        onClick={open}
      />
    </div>
  );
};

export default InlineColumnFilter;
